"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateItmStatusUpdate = exports.validateItmUpdate = exports.itmStatusUpdateSchema = exports.itmUpdateSchema = void 0;
var schema_validator_1 = require("@hobt/schema-validator");
var issue_to_management_type_1 = require("./issue-to-management-type");
var issue_to_management_status_1 = require("./issue-to-management-status");
exports.itmUpdateSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['issueToManagementRecordID'],
    properties: {
        cmhcLoanAccountNumber: {
            type: 'integer',
            minimum: 1000000,
            maximum: 99999999,
            errorMessage: 'Should be numeric between 1000000 to 99999999',
        },
        issueToManagementRecordID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        typeCodes: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'number',
                enum: Object.values(issue_to_management_type_1.IssueToManagementType),
            },
            errorMessage: 'Should equate to a valid Types Enum value',
        },
    },
};
exports.itmStatusUpdateSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['issueToManagementRecordID', 'statusCode'],
    properties: {
        issueToManagementRecordID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        statusCode: {
            type: 'integer',
            enum: Object.values(issue_to_management_status_1.IssueToManagementStatus),
            errorMessage: 'Should equate to a valid Status Enum value',
        },
    },
};
exports.validateItmUpdate = function (data) {
    var itmValidator = new schema_validator_1.SchemaValidator(exports.itmUpdateSchema, true, true, true, true);
    return itmValidator.validate(data);
};
exports.validateItmStatusUpdate = function (data) {
    var itmValidator = new schema_validator_1.SchemaValidator(exports.itmStatusUpdateSchema, true, true, true, true);
    return itmValidator.validate(data);
};
